import { render, staticRenderFns } from "./ModuleEdit.vue?vue&type=template&id=f05bf72c&scoped=true"
import script from "./ModuleEdit.vue?vue&type=script&lang=js"
export * from "./ModuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05bf72c",
  null
  
)

export default component.exports